import type { SxProps, Theme } from '@mui/material';
import type { UIFeature } from 'src/state/ui/types';
import { useNavbarExpandedUIState } from 'src/state/ui/useNavbarExpandedUIState';
import { NavAccordion } from '../NavAccordion';

type Props = {
  sx?: SxProps<Theme>;
  feature: UIFeature;
  children: React.ReactNode;
};

export const NavAccordionPersisted = ({ feature, children, sx }: Props) => {
  const { expanded, setExpanded } = useNavbarExpandedUIState(feature);

  return (
    <NavAccordion
      sx={sx}
      expanded={expanded}
      onChange={(_, value) => setExpanded(value)}
    >
      {children || <></>}
    </NavAccordion>
  );
};
